import React, { useState, useEffect } from "react";
import { getDatabase, ref, child, get } from "firebase/database";
import { initializeApp } from "firebase/app";
import Table from "react-bootstrap/Table";
import "bootstrap/dist/css/bootstrap.min.css";
import Nav from "react-bootstrap/Nav";
import logo from "../assets/images/logo.png";
import ReactPaginate from "react-paginate";

const Data = () => {
  const [showResults, setShowResults] = React.useState(false);

  const [search, setsearch] = useState("");

  const [form, setform] = useState({ toDate: "", fromDate: "" });

  const firebaseConfig = {
    apiKey: "AIzaSyBCkEw_GnuGLs1kDbS9wAyO5o2J5j9YFnQ",
    authDomain: "sunnet-sloutions.firebaseapp.com",
    databaseURL: "https://sunnet-sloutions-default-rtdb.firebaseio.com",
    projectId: "sunnet-sloutions",
    storageBucket: "sunnet-sloutions.appspot.com",
    messagingSenderId: "976566001278",
    appId: "1:976566001278:web:7cf1e2dccdf999aa4a422f",
    measurementId: "G-SCC5539GX6",
  };
  const app = initializeApp(firebaseConfig);

  const [users, setusers] = useState([]);

  let jsonString = Object.values(users);

  const [pageNumber, setPageNumber] = useState(0);
  const [listPerPage] = useState(20);
  const pagesVisited = pageNumber * listPerPage;
  const lists = jsonString.slice(pagesVisited, pagesVisited + listPerPage);
  const pageCount = Math.ceil(jsonString.length / listPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  useEffect(() => {
    const dbRef = ref(getDatabase(app));
    get(child(dbRef, "data"))
      .then((snapshot) => {
        const datas = snapshot.val();
        if (datas) {
          setusers(datas);
        } else {
          console.log("No data available");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handlechange = (e) => {
    let myUser = { ...form };
    myUser[e.target.name] = e.target.value;
    setform(myUser);
  };

  return (
    <div className="container-flied W-100">
      <Nav className="justify-content-center bg-dark">
        <Nav.Item>
          <Nav.Link>
            <img src={logo} className="logo"></img>
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <div
        style={{ background: "rgb(236,235,233)" }}
        className="pt-3 pb-3 h-100"
      >
        <div className="contact-form-block container W-100 card cardstyle mt-4">
          <div className="row">
            <div className="col-md-12 pt-3">
              {showResults ? (
                <div className="row pb-5">
                  <div className="col-md-3 col-sm-3">
                    <label className="mb-2">From Date</label>
                    <input
                      className="form-control"
                      name="fromDate"
                      type="date"
                      onChange={(e) => {
                        handlechange(e);
                      }}
                    />{" "}
                  </div>
                  <div className="col-md-3 col-sm-3">
                    <label className="mb-2">To Date</label>
                    <input
                      className="form-control"
                      name="toDate"
                      type="date"
                      onChange={(e) => {
                        handlechange(e);
                      }}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="row">
                <div className="col">
                  <h4>Data</h4>
                </div>
                <div className="col">
                  <span style={{ float: "right" }}>
                    <button
                      className="btn  filter mb-3"
                      style={{ background: "rgb(255,102,0)", color: "white" }}
                      onClick={() => {
                        setShowResults(!showResults);
                      }}
                    >
                      <i className="fa fa-filter mr-2" aria-hidden="true"></i>
                      Filter
                    </button>
                  </span>
                </div>
              </div>

              <div>
                <div style={{ float: "right" }} className="pb-3">
                  <input
                    type="search"
                    placeholder="search..."
                    className="form-control"
                    style={{ width: "100%" }}
                    onChange={(e) => {
                      setsearch(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="table-responsive">
                <Table striped bordered hover responsive>
                  <thead style={{ background: "#ff6600", color: "white" }}>
                    <tr>
                      <th>S.NO</th>
                      <th>Name</th>
                      <th>Mobile No</th>
                      <th>Location</th>
                      <th>Date</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lists
                      .filter((searchResult) => {
                        if (search === !null) {
                          return searchResult;
                        } else if (
                          searchResult.name
                            .toUpperCase()
                            .includes(search.toUpperCase())
                        ) {
                          return searchResult;
                        } else if (
                          searchResult.location
                            .toUpperCase()
                            .includes(search.toUpperCase())
                        ) {
                          return searchResult;
                        }
                      })
                      .map((data, i) => {
                        if (
                          data.date >= form.fromDate &&
                          data.date <= form.toDate &&
                          form.toDate != "" &&
                          form.fromDate != ""
                        ) {
                          return (
                            <>
                              <tr key={i}>
                                <td>{(pageNumber - 1) * 10 + i + 11}</td>
                                <td>{data.name}</td>
                                <td>{data.mobile}</td>
                                <td>{data.location}</td>
                                <td>{data.date}</td>
                                <td>{data.time}</td>
                              </tr>
                            </>
                          );
                        } else if (
                          data.date >= form.fromDate &&
                          form.toDate == ""
                        ) {
                          return (
                            <>
                              <tr key={i}>
                                <td>{(pageNumber - 1) * 10 + i + 11}</td>
                                <td>{data.name}</td>
                                <td>{data.mobile}</td>

                                <td>{data.location}</td>
                                <td>{data.date}</td>

                                <td>{data.time}</td>
                              </tr>
                            </>
                          );
                        } else if (form.fromDate == "" && form.toDate == "") {
                          return (
                            <>
                              <tr key={i}>
                                <td>{(pageNumber - 1) * 10 + i + 11}</td>
                                <td>{data.name}</td>
                                <td>{data.mobile}</td>
                                <td>{data.location}</td>
                                <td>{data.date}</td>
                                <td>{data.time}</td>
                              </tr>
                            </>
                          );
                        }
                      })}
                  </tbody>
                </Table>
                <div className="mt-3" style={{ float: "right" }}>
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    onPageChange={changePage}
                    containerClassName={"pagination"}
                    previousLinkClassName={"previousBttn"}
                    nextLinkClassName={"nextBttn"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                    total={lists.length}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Nav className="justify-content-center bg-dark">
        <Nav.Item>
          <Nav.Link>
            <p style={{ color: "white" }}>
              Copyright © -{" "}
              <span style={{ color: "rgb(255,102,0)" }}>Sunnet Solutions</span>{" "}
            </p>
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </div>
  );
};

export default Data;
